import en from './en';
import fr from './fr';

const domainMessages = {
    fr,
    en,
};

export default domainMessages;